// 대출상환/해지 모달 관리

// 커스텀 확인 대화상자 (예/아니오 버튼)
function customConfirm(message) {
  return new Promise((resolve) => {
    const modal = document.getElementById('customConfirmModal');
    const messageElement = document.getElementById('customConfirmMessage');
    const yesButton = document.getElementById('customConfirmYes');
    const noButton = document.getElementById('customConfirmNo');
    
    // 메시지 설정 (줄바꿈 지원)
    messageElement.innerHTML = message.replace(/\n/g, '<br>');
    
    // 모달 표시
    modal.style.display = 'block';
    
    // 버튼 이벤트 핸들러
    const handleYes = () => {
      modal.style.display = 'none';
      cleanup();
      resolve(true);
    };
    
    const handleNo = () => {
      modal.style.display = 'none';
      cleanup();
      resolve(false);
    };
    
    const cleanup = () => {
      yesButton.removeEventListener('click', handleYes);
      noButton.removeEventListener('click', handleNo);
    };
    
    yesButton.addEventListener('click', handleYes);
    noButton.addEventListener('click', handleNo);
  });
}

// 더미 대출 데이터 (확장된 정보 포함)
const loanData = {
  '1001-2345-6789': {
    accountNo: '1001-2345-6789',
    product: '주식담보대출 A형',
    withdrawalAccount: '8012-3456-7890',
    withdrawalName: 'DB증권',
    execDate: '2024-01-15',
    maturity: '2025-12-31',
    loanAmount: '1,500,000,000원',
    balance: '1,450,000,000원'
  },
  '1001-2345-6790': {
    accountNo: '1001-2345-6790',
    product: '주식담보대출 B형',
    withdrawalAccount: '8012-3456-7891',
    withdrawalName: 'KB증권',
    execDate: '2024-06-01',
    maturity: '2025-06-30',
    loanAmount: '350,000,000원',
    balance: '328,500,000원'
  },
  '1001-2345-6791': {
    accountNo: '1001-2345-6791',
    product: '주식담보대출 C형',
    withdrawalAccount: '8012-3456-7892',
    withdrawalName: '신한증권',
    execDate: '2025-03-01',
    maturity: '2026-03-15',
    loanAmount: '15,000,000원',
    balance: '12,500,000원'
  }
};

// 현재 선택된 계좌번호 저장
let currentAccountNo = '';
// 조회 완료 여부
let isSearched = false;

/**
 * 숫자를 한글로 변환 (원 단위 입력)
 * loan_form.js의 numberToKorean과 동일한 로직이나, 만원 단위가 아닌 원 단위로 처리
 */
function numberToKorean(num) {
  if (!num || num === 0) return '';
  
  const units = ['', '만', '억', '조'];
  const digit = ['', '일', '이', '삼', '사', '오', '육', '칠', '팔', '구'];
  
  let result = '';
  let unitIndex = 0;
  
  while (num > 0) {
    const part = num % 10000;
    if (part > 0) {
      let partStr = '';
      
      const thousand = Math.floor(part / 1000);
      const hundred = Math.floor((part % 1000) / 100);
      const ten = Math.floor((part % 100) / 10);
      const one = part % 10;
      
      if (thousand > 0) partStr += digit[thousand] + '천';
      if (hundred > 0) partStr += digit[hundred] + '백';
      if (ten > 0) partStr += digit[ten] + '십';
      if (one > 0) partStr += digit[one];
      
      result = partStr + units[unitIndex] + result;
    }
    
    num = Math.floor(num / 10000);
    unitIndex++;
  }
  
  return result + ' 원';
}

// 커스텀 드롭다운 토글
function toggleDropdown() {
  const options = document.getElementById('customOptions');
  options.classList.toggle('active');
  
  // 외부 클릭 시 닫기
  if (options.classList.contains('active')) {
    document.addEventListener('click', closeDropdownOutside);
  }
}

// 외부 클릭 시 드롭다운 닫기
function closeDropdownOutside(event) {
  const customSelect = document.getElementById('customSelect');
  const options = document.getElementById('customOptions');
  
  if (!customSelect.contains(event.target) && !options.contains(event.target)) {
    options.classList.remove('active');
    document.removeEventListener('click', closeDropdownOutside);
  }
}

// 옵션 선택 처리
document.addEventListener('DOMContentLoaded', function() {
  const customOptions = document.querySelectorAll('.custom-option');
  
  customOptions.forEach(option => {
    option.addEventListener('click', function() {
      const value = this.getAttribute('data-value');
      const text = this.textContent;
      
      // 선택된 값 업데이트
      document.querySelector('.select-text').textContent = text;
      document.getElementById('loanAccountSelect').value = value;
      
      // 선택 상태 표시
      customOptions.forEach(opt => opt.classList.remove('selected'));
      this.classList.add('selected');
      
      // 드롭다운 닫기
      document.getElementById('customOptions').classList.remove('active');
      document.removeEventListener('click', closeDropdownOutside);
    });
  });
});

// 대출계좌 조회 함수
function searchLoanAccount() {
  const selectElement = document.getElementById('loanAccountSelect');
  const accountNo = selectElement.value;

  if (!accountNo) {
    alert('대출계좌번호를 선택해주세요.');
    return;
  }

  const loan = loanData[accountNo];
  if (!loan) {
    alert('대출 정보를 찾을 수 없습니다.');
    return;
  }

  // 현재 계좌번호 저장
  currentAccountNo = accountNo;
  // 조회 완료 표시
  isSearched = true;

  // 대출 기본정보 표시
  document.getElementById('infoAccountNo').textContent = loan.accountNo;
  document.getElementById('infoProduct').textContent = loan.product;
  document.getElementById('infoWithdrawalAccount').textContent = loan.withdrawalAccount;
  document.getElementById('infoWithdrawalName').textContent = loan.withdrawalName;
  document.getElementById('infoExecDate').textContent = loan.execDate;
  document.getElementById('infoMaturity').textContent = loan.maturity;
  document.getElementById('infoLoanAmount').textContent = loan.loanAmount;
  document.getElementById('infoBalance').textContent = loan.balance;

  // 상환 신청 정보 표시 (더미 데이터)
  document.getElementById('repayName').value = '홍길동';
  
  // 주민등록번호 초기화 및 활성화 (고객이 입력)
  const rrnFront = document.getElementById('repayRrnFront');
  const rrnBack = document.getElementById('repayRrnBack');
  rrnFront.value = '';
  rrnBack.value = '';
  rrnFront.disabled = false;
  rrnBack.disabled = false;
  
  // 대출잔액에서 숫자만 추출하여 상환원금으로 설정
  const balanceNum = loan.balance.replace(/[^0-9]/g, '');
  document.getElementById('repayPrincipal').value = Number(balanceNum).toLocaleString();
  
  // 더미 이자 (실제로는 계산 필요)
  const interestAmount = 500000;
  document.getElementById('repayInterest').value = interestAmount.toLocaleString();
  
  // 상환액합계 = 상환원금 + 대출이자
  const totalAmount = Number(balanceNum) + interestAmount;
  document.getElementById('repayTotal').value = totalAmount.toLocaleString();
  
  // 상환신청액 초기화 및 활성화
  const repayAmountInput = document.getElementById('repayAmount');
  repayAmountInput.value = '';
  repayAmountInput.disabled = false;
  
  // 한글 금액 초기화
  document.getElementById('repayAmountKorean').textContent = '';
  
  // 전액상환 체크박스 초기화 및 활성화
  const fullRepayCheck = document.getElementById('fullRepayCheck');
  fullRepayCheck.checked = false;
  fullRepayCheck.disabled = false;
  
  // 버튼 초기화 (활성화 상태로 변경)
  const submitBtn = document.getElementById('repaySubmitBtn');
  submitBtn.textContent = '상환신청하기';
  submitBtn.className = 'loan-form-btn-submit';
  submitBtn.disabled = false;
  submitBtn.removeAttribute('data-action');
}

// 전액상환 체크박스 처리
async function handleFullRepayCheck() {
  const checkbox = document.getElementById('fullRepayCheck');
  const repayAmountInput = document.getElementById('repayAmount');
  const repayTotalInput = document.getElementById('repayTotal');
  const submitBtn = document.getElementById('repaySubmitBtn');
  const koreanAmountDiv = document.getElementById('repayAmountKorean');
  
  if (checkbox.checked) {
    // 상환신청액에 상환액합계 자동 입력
    repayAmountInput.value = repayTotalInput.value;
    
    // 한글 금액 표시
    const amountNum = parseInt(repayTotalInput.value.replace(/[^0-9]/g, ''));
    koreanAmountDiv.textContent = numberToKorean(amountNum);
    
    // 해지 여부 확인 (커스텀 대화상자 사용)
    const terminateConfirmed = await customConfirm('전액상환과 동시에 계좌를 해지하시겠습니까?\n\'아니오\'를 선택하면 금액 상환만 진행됩니다.');
    
    if (terminateConfirmed) {
      // 예 선택 - 해지신청 버튼으로 변경
      submitBtn.textContent = '해지신청';
      submitBtn.className = 'loan-form-btn-cancel';
      submitBtn.disabled = false;
      // 해지 플래그 저장
      submitBtn.setAttribute('data-action', 'terminate');
    } else {
      // 아니오 선택 - 상환신청 버튼으로 유지
      submitBtn.textContent = '상환신청하기';
      submitBtn.className = 'loan-form-btn-submit';
      submitBtn.disabled = false;
      // 상환 플래그 저장
      submitBtn.setAttribute('data-action', 'repay');
    }
  } else {
    // 체크 해제 시
    repayAmountInput.value = '';
    koreanAmountDiv.textContent = '';
    submitBtn.textContent = '상환신청하기';
    submitBtn.className = 'loan-form-btn-submit';
    // 버튼은 활성화 유지 (검증은 제출 시 수행)
    submitBtn.removeAttribute('data-action');
  }
}

// 상환 유형 확인 (상환액 입력 시 호출)
function checkRepaymentType() {
  const repayAmount = document.getElementById('repayAmount').value;
  const repayTotal = document.getElementById('repayTotal').value;
  const submitBtn = document.getElementById('repaySubmitBtn');
  
  if (!repayAmount) return;
  
  const repayAmountNum = parseInt(repayAmount.replace(/[^0-9]/g, ''));
  const totalAmountNum = parseInt(repayTotal.replace(/[^0-9]/g, ''));
  
  // 금액이 동일한 경우
  if (repayAmountNum === totalAmountNum) {
    // 해지 여부는 신청 버튼 클릭 시 확인
    submitBtn.textContent = '상환신청하기';
    submitBtn.className = 'loan-form-btn-submit';
  } else if (repayAmountNum < totalAmountNum) {
    // 일부 상환
    submitBtn.textContent = '상환신청하기';
    submitBtn.className = 'loan-form-btn-submit';
  }
}

// 상환/해지 신청 처리
function submitRepayment() {
  // 조회 완료 여부 확인
  if (!isSearched) {
    alert('먼저 대출계좌를 조회해주세요.');
    return;
  }
  
  // DOM 요소 가져오기
  const repayAmountInput = document.getElementById('repayAmount');
  const rrnFrontInput = document.getElementById('repayRrnFront');
  const rrnBackInput = document.getElementById('repayRrnBack');
  const submitBtn = document.getElementById('repaySubmitBtn');
  
  if (!repayAmountInput || !rrnFrontInput || !rrnBackInput || !submitBtn) {
    alert('페이지 오류가 발생했습니다. 페이지를 새로고침해주세요.');
    return;
  }
  
  // 값 가져오기
  const rrnFront = rrnFrontInput.value;
  const rrnBack = rrnBackInput.value;
  const repayAmount = repayAmountInput.value;
  const action = submitBtn.getAttribute('data-action');
  
  // 1단계: 주민등록번호 앞자리 검증
  if (rrnFront.length !== 6) {
    alert('정확한 주민등록번호를 입력해 주세요.');
    rrnFrontInput.focus();
    return;
  }
  
  // 2단계: 주민등록번호 뒷자리 검증
  if (rrnBack.length !== 7) {
    alert('정확한 주민등록번호를 입력해 주세요.');
    rrnBackInput.focus();
    return;
  }
  
  // 3단계: 상환금액 입력 여부 검증
  const cleanAmount = repayAmount.replace(/[^0-9]/g, '');
  
  if (cleanAmount === '' || cleanAmount === '0') {
    alert('상환금액을 입력해 주세요.');
    repayAmountInput.focus();
    return;
  }
  
  // 4단계: 상환금액 숫자 유효성 검증
  const repayAmountNum = parseInt(cleanAmount, 10);
  
  if (isNaN(repayAmountNum) || repayAmountNum <= 0) {
    alert('유효한 상환금액을 입력해 주세요.');
    repayAmountInput.focus();
    return;
  }
  
  // 5단계: 상환액합계 초과 여부 확인
  const repayTotal = document.getElementById('repayTotal').value;
  const totalAmountNum = parseInt(repayTotal.replace(/[^0-9]/g, ''), 10);
  
  if (repayAmountNum > totalAmountNum) {
    alert('상환신청액이 상환액합계를 초과할 수 없습니다.');
    repayAmountInput.focus();
    return;
  }
  
  // action 값을 sessionStorage에 저장 (공동인증서에서 사용)
  const certDescription = document.getElementById('certDescription');
  if (action === 'terminate') {
    sessionStorage.setItem('repaymentAction', 'terminate');
    alert('해지신청을 처리중입니다.');
    // 전자서명 안내 문구 변경
    if (certDescription) {
      certDescription.textContent = '* 해지 신청을 완료하시려면 공동인증서로 전자서명을 진행해 주세요.';
    }
  } else {
    sessionStorage.setItem('repaymentAction', 'repay');
    alert('상환신청을 처리중입니다.');
    // 전자서명 안내 문구 변경
    if (certDescription) {
      certDescription.textContent = '* 상환 신청을 완료하시려면 공동인증서로 전자서명을 진행해 주세요.';
    }
  }
  
  // TODO: 실제로는 서버에서 처리 후 다음 메시지 중 하나를 반환
  // [1] 상환신청을 처리중입니다. / 해지신청을 처리중입니다.
  // [2] 상환신청이 처리완료 되었습니다. / 해지신청이 처리완료 되었습니다.
  // [3] 신청사항 처리중 계좌확인이 필요합니다.
  
  // 공동인증서 섹션으로 스크롤 이동 및 버튼 활성화
  const certButton = document.getElementById('certButton');
  if (certButton) {
    certButton.scrollIntoView({ behavior: 'smooth', block: 'center' });
    // 스크롤 후 버튼 활성화 및 강조
    setTimeout(() => {
      // 공동인증서 버튼 활성화
      certButton.disabled = false;
      certButton.focus();
      // 상환신청하기 버튼 비활성화
      submitBtn.disabled = true;
    }, 500);
  }
}

// 모달 열기
function openRepaymentModal() {
  if (!currentAccountNo) {
    alert('먼저 대출계좌를 조회해주세요.');
    return;
  }

  const modal = document.getElementById('repaymentModal');
  const loan = loanData[currentAccountNo];

  if (!loan) {
    alert('대출 정보를 찾을 수 없습니다.');
    return;
  }

  // 대출 정보 표시
  document.getElementById('modalAccountNo').textContent = loan.accountNo;
  document.getElementById('modalProduct').textContent = loan.product;
  document.getElementById('modalBalance').textContent = loan.balance;
  document.getElementById('modalMaturity').textContent = loan.maturity;

  // 폼 초기화
  document.querySelector('input[name="repaymentType"][value="partial"]').checked = true;
  document.getElementById('repaymentAmount').value = '';
  document.getElementById('repaymentReason').value = '';
  document.getElementById('amountSection').style.display = 'block';

  // 모달 표시
  modal.style.display = 'block';

  // 라디오 버튼 이벤트 리스너
  setupRadioListeners();
}

// 모달 닫기
function closeRepaymentModal() {
  const modal = document.getElementById('repaymentModal');
  modal.style.display = 'none';
}

// 라디오 버튼 이벤트 설정
function setupRadioListeners() {
  const radioButtons = document.querySelectorAll('input[name="repaymentType"]');
  const amountSection = document.getElementById('amountSection');
  const repaymentAmount = document.getElementById('repaymentAmount');

  radioButtons.forEach(radio => {
    radio.addEventListener('change', function() {
      if (this.value === 'partial') {
        amountSection.style.display = 'block';
        repaymentAmount.required = true;
      } else {
        amountSection.style.display = 'none';
        repaymentAmount.required = false;
        repaymentAmount.value = '';
      }
    });
  });
}

// 모달 상환 신청 (모달 전용)
function submitModalRepayment() {
  const accountNo = document.getElementById('modalAccountNo').textContent;
  const repaymentType = document.querySelector('input[name="repaymentType"]:checked').value;
  const repaymentAmount = document.getElementById('repaymentAmount').value;
  const repaymentReason = document.getElementById('repaymentReason').value;

  // 유효성 검사
  if (repaymentType === 'partial') {
    if (!repaymentAmount) {
      alert('상환 금액을 입력해주세요.');
      document.getElementById('repaymentAmount').focus();
      return;
    }

    // 숫자로 변환하여 최소 금액 체크
    const amount = parseInt(repaymentAmount.replace(/,/g, ''));
    if (isNaN(amount) || amount < 1000000) {
      alert('일부 상환은 최소 100만원 이상 가능합니다.');
      document.getElementById('repaymentAmount').focus();
      return;
    }
  }

  // 신청 확인
  let confirmMessage = '';
  if (repaymentType === 'partial') {
    confirmMessage = `일부 상환 ${repaymentAmount}원을 신청하시겠습니까?`;
  } else if (repaymentType === 'full') {
    confirmMessage = '전액 상환을 신청하시겠습니까?';
  } else if (repaymentType === 'terminate') {
    confirmMessage = '대출 해지를 신청하시겠습니까?\n(전액 상환 후 계좌가 해지됩니다)';
  }

  if (confirm(confirmMessage)) {
    // 실제로는 서버에 전송

    alert('신청이 완료되었습니다.\n담당자가 확인 후 처리해드리겠습니다.');
    closeRepaymentModal();
  }
}

// 모달 외부 클릭 시 닫기
window.addEventListener('click', function(event) {
  const modal = document.getElementById('repaymentModal');
  if (event.target === modal) {
    closeRepaymentModal();
  }
});

// ESC 키로 모달 닫기
document.addEventListener('keydown', function(event) {
  if (event.key === 'Escape') {
    const modal = document.getElementById('repaymentModal');
    if (modal.style.display === 'block') {
      closeRepaymentModal();
    }
  }
});

// 상환신청액 입력 시 천단위 콤마 자동 추가 및 한글 표기
document.addEventListener('DOMContentLoaded', function() {
  const repayAmountInput = document.getElementById('repayAmount');
  const koreanAmountDiv = document.getElementById('repayAmountKorean');
  const submitBtn = document.getElementById('repaySubmitBtn');
  const fullRepayCheck = document.getElementById('fullRepayCheck');
  
  if (repayAmountInput) {
    repayAmountInput.addEventListener('input', function(e) {
      // 숫자만 추출
      let value = e.target.value.replace(/[^0-9]/g, '');
      
      if (value) {
        // 천단위 콤마 추가
        const formattedValue = parseInt(value).toLocaleString('ko-KR');
        e.target.value = formattedValue;
        
        // 한글 금액 표시
        const numValue = parseInt(value);
        koreanAmountDiv.textContent = numberToKorean(numValue);
        
        // 유효성 검증: 상환액합계 확인
        const repayTotal = document.getElementById('repayTotal').value;
        const totalAmount = parseInt(repayTotal.replace(/[^0-9]/g, ''));
        
        if (numValue > totalAmount) {
          // 상환액합계를 초과하는 경우
          koreanAmountDiv.textContent = '⚠️ 상환신청액이 상환액합계를 초과할 수 없습니다.';
          koreanAmountDiv.style.color = '#d32f2f';
          // 버튼은 활성화 유지 (검증은 제출 시 수행)
        } else {
          // 유효한 금액
          koreanAmountDiv.style.color = '#666';
          
          // 금액에 따라 처리
          if (numValue === totalAmount) {
            // 전액 상환 - 체크박스 자동 선택 및 해지 여부 확인
            if (!fullRepayCheck.checked) {
              fullRepayCheck.checked = true;
              
              // 해지 여부 확인 (커스텀 대화상자 사용)
              customConfirm('전액상환과 동시에 계좌를 해지하시겠습니까?\n\'아니오\'를 선택하면 금액 상환만 진행됩니다.').then(terminateConfirmed => {
                if (terminateConfirmed) {
                  // 예 선택 - 해지신청 버튼
                  submitBtn.textContent = '해지신청';
                  submitBtn.className = 'loan-form-btn-cancel';
                  submitBtn.setAttribute('data-action', 'terminate');
                } else {
                  // 아니오 선택 - 상환신청 버튼
                  submitBtn.textContent = '상환신청하기';
                  submitBtn.className = 'loan-form-btn-submit';
                  submitBtn.setAttribute('data-action', 'repay');
                }
              });
            }
          } else {
            // 일부 상환
            submitBtn.textContent = '상환신청하기';
            submitBtn.className = 'loan-form-btn-submit';
            submitBtn.removeAttribute('data-action');
            
            // 체크박스 자동 해제
            if (fullRepayCheck.checked) {
              fullRepayCheck.checked = false;
            }
          }
        }
      } else {
        e.target.value = '';
        koreanAmountDiv.textContent = '';
        koreanAmountDiv.style.color = '#666';
        
        // 입력값이 없는 경우 버튼 텍스트 초기화 (검증은 제출 시)
        submitBtn.textContent = '상환신청하기';
        submitBtn.className = 'loan-form-btn-submit';
        submitBtn.removeAttribute('data-action');
      }
    });
  }
  
  // 모달 관련 이벤트 (기존 코드 유지)
  const amountInput = document.getElementById('repaymentAmount');
  
  if (amountInput) {
    amountInput.addEventListener('input', function(e) {
      let value = e.target.value.replace(/[^0-9]/g, '');
      if (value) {
        value = parseInt(value).toLocaleString('ko-KR');
      }
      e.target.value = value;
    });
  }
});

/**
 * 숫자를 천단위 콤마로 포맷팅
 * @param {*} value - 변환할 숫자 값
 * @returns {string} - 천단위 콤마가 적용된 문자열
 */
export function formatNumberWithComma(value) {
  if (value == null || value === '') return '';
  const numValue = parseInt(String(value).replace(/[^0-9]/g, ''));
  if (isNaN(numValue)) return value;
  return numValue.toLocaleString('ko-KR');
}

// ES 모듈 export 및 전역 window 객체에 할당
export { customConfirm, loanData };

// window 객체에 할당하여 전역에서 사용 가능하도록 설정
if (typeof window !== 'undefined') {
  window.customConfirm = customConfirm;
  window.loanData = loanData;
  window.formatNumberWithComma = formatNumberWithComma;
}
